import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { MainComponent } from './components/main/main.component';
import { HeaderComponent } from './components/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorHandler } from './handlers/interceptor-handler';
import { FooterComponent } from './components/footer/footer.component';
import { ScenarioListDialogComponent } from './components/scenario/scenario-list-dialog/scenario-list-dialog.component';
import { ScenarioViewDialogComponent } from './components/scenario/scenario-view-dialog/scenario-view-dialog.component';
import { ScenarioCreateDialogComponent } from './components/scenario/scenario-create-dialog/scenario-create-dialog.component';
import { ChatComponent } from './components/chat/chat.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MarkdownModule } from 'ngx-markdown';
import { MondelezService } from '../shared/services/mondelez.service';
import { MondelezDataService } from '../shared/services/mondelez-data.service';
import { GlobalFilterService } from '../shared/services/global-filter.service';
import { TimeoutDialogComponent } from './components/timeout-dialog/timeout-dialog.component';
import { UnauthorizedDialogComponent } from './components/unauthorized-dialog/unauthorized-dialog.component';
import { ChatService } from './services/chat.service';

@NgModule({
  declarations: [
    MainComponent,
    HeaderComponent,
    FooterComponent,
    ScenarioListDialogComponent,
    ScenarioViewDialogComponent,
    ScenarioCreateDialogComponent,
    ChatComponent,
    TimeoutDialogComponent,
    UnauthorizedDialogComponent,
  ],
  imports: [CommonModule, SharedModule, DragDropModule, MarkdownModule.forRoot()],
  providers: [MondelezService, GlobalFilterService, ChatService, MondelezDataService, { provide: HTTP_INTERCEPTORS, useClass: InterceptorHandler, multi: true }, DatePipe],
  exports: [HeaderComponent, FooterComponent],
})
export class CoreModule {}
